enum ModalToOpen {
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	Publish = "Publish",

	ShareTicketHandler = "ShareTicketHandler",
	ReviewTicketHandler = "ReviewTicketHandler",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	PullHandler = "PullHandler",

	SnippetAlreadyUseWarn = "SnippetAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	MergeRequestConfirm = "MergeRequestConfirm",
	CreateSourceData = "CreateSourceData",

	EditEnterpriseConfig = "EditEnterpriseConfig",

	TemplateContentWarning = "TemplateContentWarning",
	TemplatePropertySettings = "TemplatePropertySettings",

	DocRootMissingModal = "DocRootMissingModal",
}

export default ModalToOpen;
